import pic1 from "../assets/pic1.png"
import pic2 from "../assets/pic2.png"
import pic3 from "../assets/pic3.png"
import pic4 from "../assets/pic4.png"
import pic5 from "../assets/pic5.png"
import pic6 from "../assets/pic6.png"
import pic7 from "../assets/pic7.png"
import pic8 from "../assets/pic8.png"
import pic9 from "../assets/pic9.png"
import pic10 from "../assets/pic10.png"
import pic11 from "../assets/pic11.png"
import pic12 from "../assets/pic12.png"
import pic13 from "../assets/pic13.png"
import pic14 from "../assets/pic14.png"
import pic15 from "../assets/pic15.png"

export const Logos = [
  {
    img: pic12,
  },
  {
    img: pic10,
  },
  {
    img: pic9,
  },
  {
    img: pic14,
  },
  {
    img: pic15,
  },
  {
    img: pic13,
  },
  {
    img: pic11,
  },
]

export const Cards = [
  {
    img: pic1,
    name: "Hard Rock Cafè",
    sub: "Restaurant",
  },
  {
    img: pic2,
    name: "Just Used",
    sub: "Gadgets",
  },
  {
    img: pic3,
    name: "Okayfones",
    sub: "Gadgets",
  },
  {
    img: pic4,
    name: "Ogabassey",
    sub: "Gadgets",
  },
  {
    img: pic5,
    name: "Sales366",
    sub: "Gadgets",
  },
  {
    img: pic6,
    name: "Dreamworks",
    sub: "Gadgets",
  },
  {
    img: pic7,
    name: "SLots",
    sub: "Gadgets",
  },
  {
    img: pic8,
    name: "Casper",
    sub: "Gadgets",
  },
]
